import * as React from 'react';
import { FC } from 'react';
import { PointMarkerIconProps } from '../../types/map';

export const PointMarkerIcon: FC<PointMarkerIconProps> = ({ type, color }) => {
    if (!type) return null;

    return (
        <>
            {
                {
                    'point-start': (
                        <svg width="24" fill={color} height="24" viewBox="0 0 24 24">
                            <circle fill="#FFFFFF" cx="12" cy="12" r="10" />
                            <circle fill="#000000" cx="12" cy="12" r="6" />
                        </svg>
                    ),
                    'point-finish': (
                        <svg width="24" fill={color} height="24" viewBox="0 0 24 24">
                            <circle fill="#FFFFFF" cx="12" cy="12" r="10" />
                            <circle fill="#000000" cx="12" cy="12" r="6" />
                        </svg>
                    ),
                    'point-segment': (
                        <svg width="24" fill={color} height="24" viewBox="0 0 24 24">
                            <circle fill="#FFFFFF" cx="12" cy="12" r="10" />
                            <circle fill="#E2E2E2" cx="12" cy="12" r="6" />
                        </svg>
                    ),
                    point: (
                        <svg width="24" fill={color} height="24" viewBox="0 0 24 24">
                            <circle fill="#FFFFFF" cx="12" cy="12" r="10" />
                            <circle fill="#E2E2E2" cx="12" cy="12" r="6" />
                        </svg>
                    ),
                }[type]
            }
        </>
    );
};
